import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { applicationStore, roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../store/gameStore';
// import LogoImg from '../../assets/images/turbo-poker/logo.png';

export const MobileHeaderSection = observer(() => {
  const { roundId } = roundInfoStore;
  const { isDemo } = applicationStore;
  const { resetGameState } = gameStore;
  const t = useTranslation();

  const handleDemoSwitcher = useCallback(() => {
    applicationStore.demoSwitcher(resetGameState);
  }, [resetGameState]);

  return (
    <div className='tp-game-mobile-header'>
      <div className='tp-game-mobile-header-holder'>
        <div className='tp-g-mob-round'>
          <div className='tp-g-mob-round-inside'>
            {!isDemo && (
              <>
                <p className='tp-g-mob-round-txt'>{t('ROUND_ID')}</p>
                <p className='tp-g-mob-round-id'>{roundId}</p>
              </>
            )}
          </div>
        </div>
        <div className='tp-g-mob-logo'>{/* <img src={LogoImg} alt='' /> */}</div>
        <div className='tp-g-mob-btn-play-wrp'>
          {isDemo && (
            <button onClick={handleDemoSwitcher} className='play-for-real-btn'>
              {t('PLAY_FOR_REAL')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
});
